import { Callback } from 'src/util/query/models/Callback';

class MailReceiverGroupsCallback<ResponseType> extends Callback<ResponseType> {
	public constructor(
		private readonly resolve: (value: ResponseType) => void,
		private readonly reject: (reason?: unknown) => void
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
		this.reject(failureResponse);
	};

	successCallbackFunction = (successResponse: ResponseType): void => {
		this.resolve(successResponse);
	};
}

export { MailReceiverGroupsCallback };
